export const paragraphDefaultContent = {
    en: {
        paragraphText: {
            content: 'Dive into the present moment with awareness. The past has offered lessons, while the future brims with possibilities.'
        },
    },
    es: {
        paragraphText: {
            content: 'Sumérgete en el momento presente con conciencia. El pasado ha ofrecido lecciones, mientras que el futuro rebosa de posibilidades.'
        }
    }
}
